<template>
  <div :class="{'flex-m one-line-flex':xsid}" class="course-header flex">
    <div v-if="!xsid" class="top_header flex">
      <p class="flex flex-m" @click="showSchools">
        <span class="name">{{ campusName }}</span>
        <svg-icon icon-class="icon_change"/>
      </p>
      <svg-icon
        :icon-class="layoutType === 'normal' ? 'home_style_grid' : 'home_style_normal'"
        class-name="style-switch"
        @click="onClickSwitchStyle" />
      <van-badge :content="cartNum===0?'':cartNum" class="cart">
        <svg-icon icon-class="cart" class-name="cart" @click="toShort" />
      </van-badge>
    </div>
    <div v-if="!xsid" class="bottom_header flex flex-m">
      <p class="grade" @click="showGrade = true;">
        <span>{{ gradeInfoStr }}</span>
        <svg-icon icon-class="select_triangle"/>
      </p>
      <select-grade :grade-list="newGradeList" :show-grade="showGrade" @confirm="gradeConfirm" @cancel="gradeCancel"/>
      <van-search readonly class="search" placeholder="搜索课程" @click="toSearch" />
    </div>
    <div v-if="xsid" class="flex flex-m one-line-header">
      <p class="grade" @click="showGrade = true;">
        <span>{{ gradeInfoStr }}</span>
        <svg-icon icon-class="select_triangle"/>
      </p>
      <select-grade :grade-list="newGradeList" :show-grade="showGrade" @confirm="gradeConfirm" @cancel="gradeCancel"/>
      <van-search readonly class="search" placeholder="搜索课程" @click="toSearch" />
      <svg-icon
        :icon-class="layoutType === 'normal' ? 'home_style_grid' : 'home_style_normal'"
        class-name="style-switch"
        @click="onClickSwitchStyle" />
      <van-badge v-if="cartNum > 0" :content="cartNum" class="cart">
        <svg-icon icon-class="cart" class-name="cart" @click="toShort" />
      </van-badge>
      <van-badge v-else class="cart">
        <svg-icon icon-class="cart" class-name="cart" @click="toShort" />
      </van-badge>
    </div>
  </div>
</template>

<script>
import selectGrade from '../../components/mine/selectGrade.vue';
import { Search, Badge, Icon, Toast } from 'vant';
export default {
  name: 'CourseHeader',
  components: {
    [Search.name]: Search,
    [Badge.name]: Badge,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    selectGrade
  },
  props: {
    // 商品名称关键词
    keywords: {
      type: String,
      default: ''
    },
    // 年级列表
    gradeList: {
      type: Array,
      default: () => ({})
    },
    // 默认年级名称
    gradeStr: {
      type: String,
      default: ''
    },
    // 购物车数量
    cartNum: {
      type: Number,
      default: 0
    },
    isShowCart: {
      type: Boolean,
      default: false
    },
    gradeCode: {
      type: String,
      default: 'undefined'
    },
    firstCampus: {
      type: Object,
      default: () => ({})
    },
    layoutType: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      showGrade: false,
      gradeInfoStr: '',
      newGradeList: [],
      campusName: '',
      xsid: this.$route.query.code || ''
    };
  },
  watch: {
    /**
     * 使底部tabbar的z-index小于年级列表的弹出框
     */
    showGrade(val) {
      if (val) {
        this.$emit('parentBottom', true);
        document.body.style.overflow = 'hidden';
      } else {
        this.$emit('parentBottom', false);
        document.body.style.overflow = 'auto';
      }
    },
    gradeStr(val) {
      this.gradeInfoStr = this.gradeStr;
      this.setDefault();
    },
    gradeList(val, oldVal) {
      if (val.length > 0 && oldVal.length === 0) {
        this.init();
      }
    },
    firstCampus(val, oldVal) {
      console.log(val, oldVal);
      if (val) {
        this.campusName = val.campusName;
      }
    }
  },
  activated() {
    this.gradeInfoStr = this.gradeStr;
    this.setDefault();
  },
  async mounted() {
    if (this.firstCampus.campusName) {
      this.campusName = this.firstCampus.campusName;
    }
    this.$nextTick(() => {
      if (this.gradeList.length > 0) {
        this.init();
      }
    });
  },
  methods: {
    onClickSwitchStyle() {
      console.log('sfsfsfsf');
      this.$emit('styleChange');
    },
    // 校区弹出框
    showSchools() {
      this.$emit('changeSchool', true);
    },
    init() {
      this.gradeInfoStr = this.gradeStr;
      this.newGradeList = this.gradeList;
      this.newGradeList.unshift({
        rows: [{
          gradeCode: '',
          gradeName: '全部年级',
          gradeSort: 1,
          isDefault: 0
        }]
      });
      this.setDefault();
    },
    setDefault() {
      this.newGradeList.forEach(element => {
        if (element.rows.length > 0) {
          element.rows.forEach(item => {
            if (item.gradeName === this.gradeInfoStr) {
              this.$set(item, 'checked', true);
            } else {
              this.$set(item, 'checked', false);
            }
          });
        }
      });
    },
    toSearch() {
      this.$router.push({ name: 'CourseSearch' });
    },
    /**
     * 点击左边icon
     * 返回上一层级
     */
    onClickLeft() {
      this.$router.go(-1);
    },
    gradeConfirm(grade) {
      if (!grade) {
        grade = {
          gradeCode: '',
          gradeName: '全部年级'
        };
      }
      let obj = {
        gradeCode: grade.gradeCode + '',
        gradeName: grade.gradeName
      };
      console.log(obj);
      this.$emit('changeGrade', obj);
      this.gradeInfoStr = grade.gradeName;
      this.showGrade = false;
    },
    gradeCancel() {
      this.showGrade = false;
    },
    // 选课单
    toShort() {
      if (this.isShowCart) {
        this.$router.push({ name: 'CourseSheet' });
      } else {
        Toast('请先登录');
      }
    }
  }
};
</script>
<style scoped lang="scss">
.course-header {
  width: 100%;
  height: 158px;
  position: fixed;
  top: 0;
  background: $white;
  font-size: 28px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .top_header {
    height: 86px;
    width: 100%;
    padding: 0 30px;
    justify-content: space-between;
    align-items: center;

    .style-switch {
      margin-right: 50px;
      width: 40px;
      height: 40px;
    }
    .cart {
      width: 40px;
      height: 40px;
    }
    p {
      .name {
        max-width: 400px;
        height: 44px;
        font-size: 32px;
        color: rgba($dark-black, 0.85);
        font-weight: bold;

        @extend %one-line-text-overflow ;
      }

      svg {
        width: 52px;
        height: 52px;
      }
    }
  }

  .bottom_header {
    height: 72px;
    width: 100%;
    justify-content: space-between;
  }

  .grade {
    max-width: 178px;
    padding-left: 30px;
    white-space: nowrap;

    span {
      color: rgba($dark-black, 0.65);
      font-weight: bold;
      font-size: 28px;
    }

    .svg-icon {
      width: 20px;
      height: 20px;
      vertical-align: baseline;
    }
  }

  /deep/ .van-search {
    width: 668px;
    height: 64px;

    .van-search__content {
      background-color: #f6f6f6;
      border-radius: 34px;
    }

    .van-field__left-icon {
      color: lighten($dark-black, 55%);
    }
  }

  /deep/ .van-badge__wrapper {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 30px;

    .van-icon {
      font-size: 40px;
    }

    .van-badge {
      background-color: $red;
    }
  }

  /deep/ .grade-content {
    z-index: 9999;
    height: 100%;
  }

  >>>.grade-content .grade-item-content {
    padding-top: 10px;
    padding-bottom: 20px;
  }
}

.one-line-flex {
  height: 92px;
}

.one-line-header {
  width: 100%;
  padding-left: 30px;

.style-switch {
    margin-right: 50px;
    width: 40px;
    height: 40px;
  }
  .cart {
      width: 40px;
      height: 40px;
  }
  /deep/ .van-search {
    width: 430px;
    padding: 12px 0;
    margin-right: 10px;
  }

  .grade {
    padding-left: 0;
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/course.vue